export default __webpack_public_path__ + "static/media/Certificate.d35f1003.svg";